import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
    selector: "[window-type-5]",
    templateUrl: "./window-type-5.component.html",
    styleUrl: "./window-type-5.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WindowType5Component {
  public height = input<number>();
  public windowWidth: number = 22;

  public leftWindowPositions = computed(() =>
    this.generateWindows({
      columns: 7,
      initialHeight: this.height(),
      xStart: 7,
      yStart: 120,
      rowMargin: 12,
      rowHeight: 40,
      adjustMargin: true,
    })
  );

  public rightWindowPositions = computed(() =>
    this.generateWindows({
      columns: 5,
      initialHeight: this.height(),
      xStart: 190,
      yStart: 190,
      rowMargin: 12,
      rowHeight: 40,
      adjustMargin: false,
    })
  );

  /**
   * Generalized method to generate window positions for both left and right sides.
   * @param config - Configuration object containing window parameters
   * @returns Array of window positions
   */
  private generateWindows(config: {
    columns: number;
    initialHeight: number;
    xStart: number;
    yStart: number;
    rowMargin: number;
    rowHeight: number;
    adjustMargin: boolean;
  }) {
    const { columns, initialHeight, xStart, yStart, rowMargin, rowHeight, adjustMargin } = config;
    const rows = Math.floor((initialHeight - 100) / (rowHeight + rowMargin));

    return Array.from({ length: columns }, (_, i) =>
      Array.from({ length: rows }, (_, j) => {
        const extraXSpace = i >= 5 ? 20 : 0; // Add 20px after the 5th column
        const extraYSpace = i >= 5 ? 10 : 0;
        const x = xStart + i * 20 + extraXSpace; // Adjust x-spacing
        const y = yStart + j * 30 + extraYSpace + (adjustMargin ? i * rowMargin : -i * rowMargin);

        // Randomize whether the entire row is lit or off
        const isRowLit = Math.random() > 0.5;

        return { x, y, isLit: isRowLit };
      })
    );
  }

  public trackByIndex = (index: number) => index;
}
